export default "__VITE_ASSET__40fd1d33__"